import { createEffect } from 'effector';

export const downloadPostCardOnDesktopFx = createEffect<HTMLCanvasElement, null, Error>(
  (canvas: HTMLCanvasElement) => {
    const image = canvas.toDataURL('image/png', 1.0);
    const fakeLink = window.document.createElement('a');
    fakeLink.download = 'diplom.png';
    fakeLink.href = image;

    document.body.appendChild(fakeLink);

    fakeLink.click();
    document.body.removeChild(fakeLink);

    return null;
  }
);
